<template>
  <v-card outlined>
    <v-card-text>
      <v-data-table id="subscription-cart" :search="search" :headers="headers" hide-default-footer :itemsPerPage="1000"
        no-data-text="No item on this subscription yet" :items="SubscriptionDetails">
        <template v-slot:item="{ item, index }">
          <tr :style="{ 'background-color': activeColor(item) }">
            <td>
              <v-layout align-center justify-start row fill-height wrap>
                <v-btn icon @click="deleteItem(index)" v-if="!item.delete">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <v-btn icon @click="unDeleteItem(index)" v-else>
                  <v-icon color="green">mdi-delete-empty</v-icon>
                </v-btn>
                <v-text-field v-if="!item.delete" v-model="item.name" outlined hide-details
                  @focus="$event.target.select()" dense></v-text-field>
                <span v-else :class="{ deleted: item.delete }">{{
                  item.name
                  }}</span>
              </v-layout>
            </td>

            <td class="text-center">
              <v-text-field v-if="!item.delete" v-model="item.qty" :disabled="item.imeiNumber ? true : false" outlined
                type="number" class="centered-input" hide-details dense @focus="$event.target.select()"></v-text-field>
              <span v-else :class="{ deleted: item.delete }">{{
                item.qty
                }}</span>
            </td>
            <td class="text-right">
              <v-text-field v-if="!item.delete" v-model="item.price" outlined :min="0"
                prepend-inner-icon="mdi-clipboard-check-outline" class="al-r" type="number"
                @click:prepend-inner="copyPrice(item, index)" hide-details @blur="checkPrice(item)"
                @focus="$event.target.select()" dense></v-text-field>
              <span v-else :class="{ deleted: item.delete }">{{
                item.price | currency
                }}</span>
            </td>
            <td class="text-right">
              <span :class="{ deleted: item.delete }" :style="{
                color:
                  parseFloat(item.price) > parseFloat(item.cost)
                    ? 'green'
                    : 'red',
              }">{{ (item.qty * item.price) | currency }}</span>
              <span v-if="showCost">
                <span v-if="checkRightStatus(42)">
                  <v-text-field v-if="showCost" v-model="item.cost" outlined class="al-r" hide-details
                    @focus="$event.target.select()" dense></v-text-field>
                </span>

                <span v-else>/{{ item.cost | currency }}</span>
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
// const ReturnPhone = () => import("./ReturnPhone");

import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      openDialog: false,
      selectedItem: null,
      htmlHeight: 0,
      showCost: false,
      search: null,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "Quantity",
          align: "center",
          value: "qty",
          width: "100",
          sortable: false,
        },
        {
          text: "Price",
          align: "right",
          value: "price",
          sortable: false,
        },
        {
          text: "Total",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("subscription", [
      "SubscriptionDetails",
      "totalQty",
      "getSelectedCustomer",
    ]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    replaceQty() {
      let value = 0;
      this.SubscriptionDetails.map((row) => {
        if (row.needIMEINumber && !row.delete) value += row.qty;
      });

      return value;
    },
    selectedCustomer: {
      get: function () {
        return this.getSelectedCustomer;
      },
      set: function (val) {
        this.SetSelectedDonor(val);
      },
    },
  },
  // components: {
  //   ReturnPhone,
  // },
  watch: {
    selectedCustomer() {
      this.changeHeight();
    },
  },
  mounted() {
    this.htmlHeight = document.documentElement.offsetHeight;
    this.changeHeight();
  },
  methods: {
    ...mapActions("subscription", [
      "AddSubscriptionDetail",
      "SetSelectedDonor",
      "DeleteSubscriptionDetailRow",
      "UnDeleteSubscriptionDetailRow",
      "CopyPriceToAll",
    ]),
    openIMEICollect(item) {
      console.log("click here");
      this.openDialog = true;
      this.selectedItem = item;
    },
    activeColor(item) {
      let result = "transparent";
      if (item.receivedAt) result = "#FFFDE7";
      return result;
    },
    changeHeight() {
      let html = this.htmlHeight;
      let alert = document.getElementById("alert-col");

      if (alert) {
        alert = alert.offsetHeight;
      } else {
        alert = 0;
      }
      let newHeight = html - (580 + alert) + "px";
      document.getElementById("subscription-cart").style.height = newHeight;
    },
    copyPrice(item, index) {
      this.$swal({
        title: "Change Price To All",
        text: `You want to change all ${item.name
          } price to ${this.$options.filters.currency(item.price)}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.CopyPriceToAll(index);
        }
      });
    },
    async unDeleteItem(i) {
      await this.UnDeleteSubscriptionDetailRow(i);
      this.$swal
        .mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        })
        .fire({
          icon: "success",
          title: "Item was restore",
        });
    },
    deleteItem(i) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.DeleteSubscriptionDetailRow(i);
          // this.Invoice.SubscriptionDetails.splice(i, 1);
        }
      });
    },
    checkPrice(item) {
      if (parseFloat(item.price) < item.cost) {
        this.$swal({
          title: "Selling Blow Cost Price",
          text: `${item.name} cost price is ${this.$options.filters.currency(
            item.cost
          )}. You are selling it for ${this.$options.filters.currency(
            item.price
          )}below cost price. Are you sure?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        }).then((result) => {
          if (!result.value) {
            item.price = item.previousPrice;
            item.total = parseFloat(item.price) * parseFloat(item.qty);
          }
        });
      } else {
        item.total = parseFloat(item.price) * parseFloat(item.qty);
      }
    },
    insertReturn(val) {
      console.log("insert return", val);
      const imeiResult = this.SubscriptionDetails.find(
        ({ imeiNumber }) => imeiNumber === val.imeiNumber
      );

      if (imeiResult) {
        this.$swal({
          title: "Return Item",
          text: "This item is already in list",
          icon: "error",
        });
        // this.$swal
        //   .mixin({
        //     toast: true,
        //     position: "top-right",
        //     showConfirmButton: true,
        //     timer: 3000,
        //   })
        //   .fire({
        //     icon: "error",
        //     title: `${val.imeiNumber} is already in this list`,
        //   });
      } else {
        this.AddSubscriptionDetail({
          ProductId: val.ProductId,
          name: val.name,
          price: Math.abs(val.returnPrice),
          qty: -1,
          total: val.price * -1,
          cost: val.cost,
          imeiNumber: val.imeiNumber,
          lock: true,
        });
      }
    },
  },
};
</script>

<style scoped>
#subscription-cart {
  overflow: auto;
}
</style>
